<template>
    <footer class="footer light-text">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="align-items-center">
                        <p class="fs-5"><b>Canais oficiais</b></p>
                        <ul class="mx-auto">
                            <li class="rounded my-1"> <i class="bi bi-whatsapp"></i> (33) 98899-5347</li>
                            <li class="rounded my-1"> <i class="bi bi-phone"></i> (33) 99940-5347</li>
                            <li class="rounded my-1"> <i class="bi bi-envelope-at-fill"></i> nossaalianca.consult@gmail.com </li>
                        </ul>
                    </div>
                </div>

                <div class="col-md-4">
                    <div id="footer-nav" class="align-items-center">
                        <p class="fs-5"><b>Links</b></p>
                        <ul class="mx-auto">
                            <li class="rounded my-1">
                                <router-link to="/" class="nav-link">Início</router-link>
                            </li>
                            <li class="rounded my-1">
                                <router-link to="/sobre" class="nav-link">Sobre</router-link>
                            </li>
                            <li class="rounded my-1">
                                <router-link to="/contato" class="nav-link">Contato</router-link>
                            </li>
                        </ul>
                    </div>
                </div >
                <div class="col-md-4 d-flex align-items-center">
                    <p class="text-center">&copy; 2024 Nossa Aliança Consultoria. Todos os direitos reservados.</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Foot'
}
</script>

<style scoped>
.footer {
    background-color: #003867;
    color: #ffffff;
    padding: 10px 0;
}
.footer p {
    margin: 0;
}
.footer ul {
    padding: 0;
    list-style-position: inside;
}

#footer-nav {
    padding-left: 45%;
}
#footer-nav ul {
    padding-left: 0; /* Remove o padding padrão da lista */
    list-style: none; /* Remove os marcadores da lista */
}
#footer-nav li {
    margin-left: 0; /* Remove a margem esquerda dos itens da lista */
    padding-left: 0; /* Remove o padding esquerdo dos itens da lista */
}
#footer-nav .nav-link:hover {
    text-decoration: underline; /* Adiciona sublinhado ao passar o mouse */
}
</style>